///////COMPONENTS///////
import { put, takeLatest, select } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { errorManagerActionCreators, globalLoadingActionCreators, loginActionCreators, tableActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API } from '../../config/AxiosConfig'
import { selectTableReferential } from '../selectors/user'
import { isEmpty } from 'lodash'

const getLogin = function* ({ payload }) {
	const userCredentials = {
		username: payload.login,
		password: payload.password,
		idLanguage: payload.idLanguage,
	}

	const apiCall = R.GET_BEARER_TOKEN()

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const token = yield API.post(apiCall, userCredentials)

		const dataOld = yield API.get('/current-user', { headers: { Authorization: `Bearer ${token.data.jwttoken}` } })
		dataOld.data['jwttoken'] = token.data.jwttoken

		const apiCallTableReferential = R.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY()

		try {
			const dataTableTableReferential = yield API.get(apiCallTableReferential, { headers: { Authorization: `Bearer ${token.data.jwttoken}` } })
			yield put(tableActionCreators.getAllSavedTableColumnsDisplaySuccess(dataTableTableReferential.data))
		} catch (errorTableReferential) {
			yield put(tableActionCreators.getAllSavedTableColumnsDisplayFailure(errorTableReferential.response))
		}

		yield put(loginActionCreators.getLoginSuccess(dataOld.data))
	} catch (e) {
		yield put(loginActionCreators.getLoginFailure(e.response))
	} finally {
		//const token = yield API.post(apiCall, userCredentials)
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getCurrentUser = function* ({ payload }) {
	const tableReferential = yield select(selectTableReferential)
	const token = payload.token
	const apiCall = R.GET_CURRENT_USER()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API.get(apiCall, { headers: { Authorization: `Bearer ${token}` } })
		data.data['jwttoken'] = token
		const apiCallTableReferential = R.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY()

		try {
			const dataTableTableReferential = yield API.get(apiCallTableReferential, { headers: { Authorization: `Bearer ${token}` } })

			yield put(tableActionCreators.getAllSavedTableColumnsDisplaySuccess(dataTableTableReferential.data))
		} catch (errorTableReferential) {
			yield put(tableActionCreators.getAllSavedTableColumnsDisplayFailure(errorTableReferential.response))
		}

		yield put(loginActionCreators.getLoginSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(loginActionCreators.getLogout())

		yield put(loginActionCreators.getLoginFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postForgotPassword = function* ({ payload }) {
	const userCredentials = {
		userName: payload.login,
	}

	const apiCall = R.POST_FORGOT_PASSWORD()

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API.post(apiCall, userCredentials)
		yield put(loginActionCreators.postForgotPasswordSuccess(data.status))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(loginActionCreators.postForgotPasswordFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postForgotLogin = function* ({ payload }) {
	const userCredentials = {
		email: payload.login,
	}

	const apiCall = R.POST_FORGOT_LOGIN()

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API.post(apiCall, userCredentials)
		yield put(loginActionCreators.postForgotLoginSuccess(data.status))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(loginActionCreators.postForgotLoginFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_LOGIN, getLogin)
	yield takeLatest(ActionsTypes.GET_CURRENT_USER, getCurrentUser)
	yield takeLatest(ActionsTypes.POST_FORGOT_PASSWORD, postForgotPassword)
	yield takeLatest(ActionsTypes.POST_FORGOT_LOGIN, postForgotLogin)
}

export default sagas
